module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Compatibilty configurator"},"fr":{"title":"Configurateur compatibilité"}}')
  delete Component.options._Ctor
}
